import { DIFF_DELETE, DIFF_INSERT } from 'diff-match-patch';

import { diffsToDiffSegments } from './diff-utils';
import { normalizeRangeInDiff } from './normalizeRangeInDiff';
import type { Change, DiffSegment } from './types';
import { diffWordsSemantic } from './word-diff';

export type { Change, DiffSegment };

/**
 * Word-level semantic diff (diff-match-patch engine) adapted to the
 * layered-diffs `DiffSegment[]` format, with range markers normalized.
 */
export function semanticDiffToSegments(
  oldText: string,
  newText: string,
  id: string
): DiffSegment[] {
  const rawDiffs = diffWordsSemantic(oldText, newText);
  return normalizeRangeInDiff(diffsToDiffSegments(rawDiffs, id));
}

/**
 * Word-level semantic diff (diff-match-patch engine) adapted to the
 * jsdiff-compatible `Change[]` format.
 *
 * The conversion exists because the diff engine was swapped from jsdiff to
 * diff-match-patch, but consumers still expect jsdiff's `{ value, added,
 * removed }` shape. See {@link Change}.
 */
export function semanticDiffToChanges(oldText: string, newText: string): Change[] {
  return diffWordsSemantic(oldText, newText).map<Change>(([op, data]) => ({
    added: op === DIFF_INSERT,
    removed: op === DIFF_DELETE,
    value: data,
  }));
}
